// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { formActions, mergeActionsToProps } from 'redux-pure-form';
import instadate from 'instadate';
import Select from '../../form/select.js';
import Datepicker from '../../common/datepicker/datepicker';

import {
  selectRepsIntervalOptions,
  selectRecurringTypeOptionsOptions
} from '../calendar.selectors.js';

import { dateFormatSettings } from '../../settings/settings.consts.js';

import { getRecurringSettings, formatDate, newDate, getMinutes } from '../calendar.model.js';

import { weekDayNames, defaultEventFormRecurring, dayHalf } from '../calendar.consts.js';

import { checkEventParams } from '../calendar-day.actions.js';

class EventRecurring extends React.Component {
  static footer = false;

  constructor(props: Props) {
    super(props);
    this.handleRepsIntervalChange = this.handleChange.bind(this, 'repsInterval');
    this.handleRecurringTypeChange = this.handleChange.bind(this, 'recurringType');
    this.handleWeekDayChange = this.handleChange.bind(this, 'daysOfWeek');
    this.handleRepsTypeChange = this.handleChange.bind(this, 'repsType');
    this.handleEndDateChange = this.handleChange.bind(this, 'recurringEndDate');

    this.handeRecurringCancel = this.handeRecurringClose.bind(this, 'cancel');
    this.handeRecurringApply = this.handeRecurringClose.bind(this, 'apply');
  }

  handleChange(name, e) {
    let value;

    switch (name) {
      case 'repsInterval':
      case 'recurringType':
        value = e.currentTarget.value;
        break;
      case 'daysOfWeek':
        const nextValue = e.currentTarget.dataset.key;
        const checkedIndex = this.props.eventForm.daysOfWeek.indexOf(nextValue);
        value =
          checkedIndex > -1
            ? [
                ...this.props.eventForm.daysOfWeek.slice(0, checkedIndex),
                ...this.props.eventForm.daysOfWeek.slice(checkedIndex + 1)
              ]
            : [...this.props.eventForm.daysOfWeek, nextValue];
        break;
      case 'repsType':
        const type = e.currentTarget.dataset.type;
        value = type;
        break;
      case 'recurringEndDate':
        const minutes = getMinutes(
          this.props.eventForm.startTime,
          this.props.eventForm.timezone.offset,
          false
        );
        value =
          (instadate.noon(instadate.resetTimezoneOffset(e)).getTime() +
            minutes * 60 * 1000 -
            dayHalf) /
          1000;
        break;
    }

    this.props.fieldAttrs.onChange(`eventForm.${name}`, value);

    return this.props.checkEventParams();
  }

  handeRecurringClose(buttonType) {
    if (buttonType === 'cancel') {
      this.props.fieldAttrs.onChange({
        eventForm: {
          ...this.props.eventForm,
          ...defaultEventFormRecurring,
          recurringEndDate: this.props.eventForm.startTime
        }
      });
    }

    if (!this.props.eventForm.reps.length) {
      this.props.fieldAttrs.onChange('eventForm.reps', '0');
    }

    const { URL } = this.props;
    return this.props.switchModals(
      URL.eventBreadcrumbs[URL.eventBreadcrumbs.length - 2].action,
      URL.eventParams,
      URL.eventBreadcrumbs.slice(0, -1)
    );
  }

  render() {
    const { eventForm, user, eventModalData, fieldAttrs } = this.props;

    const isDateRepsType = eventForm.repsType === 'date';
    const isNumberRepsType = eventForm.repsType === 'number';

    return (
      <form>
        <div className="repeat-every">
          <Select
            value={eventForm.repsInterval}
            id="repsInterval"
            label="Repeat Every"
            className="form-control input-sm"
            options={this.props.repsIntervalOptions}
            onChange={this.handleRepsIntervalChange}
          />
          <Select
            value={eventForm.recurringType}
            id="recurringType"
            className="form-control input-sm"
            options={this.props.recurringTypeOptions}
            onChange={this.handleRecurringTypeChange}
          />
        </div>

        {eventForm.recurringType === 'weeks' ? (
          <div className="form-group">
            <label>Repeat On</label>
            <br />
            {Object.keys(weekDayNames).map(key => {
              const checked = eventForm.daysOfWeek.indexOf(key) !== -1;
              return (
                <span key={weekDayNames[key].full}>
                  <label>
                    <input
                      type="checkbox"
                      checked={checked}
                      data-key={key}
                      disabled={eventForm.daysOfWeek.length === 1 && checked}
                      onChange={this.handleWeekDayChange}
                    />
                    {weekDayNames[key].short}
                  </label>{' '}
                </span>
              );
            })}
          </div>
        ) : null}

        <div className="form-group">
          <label>Ends</label>
          <div>
            <div className="form-inline">
              <label>
                <input
                  type="radio"
                  data-type="number"
                  checked={isNumberRepsType}
                  onChange={this.handleRepsTypeChange}
                />
                <span className="after-text">after</span>
              </label>
              <input
                type="number"
                name="eventForm.reps"
                className="form-control input-sm"
                value={eventForm.reps || ''}
                disabled={isDateRepsType}
                {...fieldAttrs}
              />
              <div className="help-block-horizonstal clean">times</div>
            </div>
            <div className="form-inline on-wrap">
              <label className="on-wrap-label">
                <input
                  type="radio"
                  data-type="date"
                  checked={isDateRepsType}
                  onChange={this.handleRepsTypeChange}
                />
                <span className="after-text">on</span>
              </label>
              <Datepicker
                id="recurringEndDate"
                className="form-control inner-datepicker input-sm"
                disabled={isNumberRepsType}
                required={isNumberRepsType}
                selected={
                  eventForm.recurringEndDate
                    ? newDate(eventForm.recurringEndDate, eventForm.timezone.offset, false)
                    : null
                }
                onChange={this.handleEndDateChange}
                dateFormat={user.settings.date}
              />
            </div>
          </div>
        </div>

        {eventForm.recurring === '1' ? (
          <div className="form-group">
            <label>Summary</label>
            <p className="form-control-static">
              {getRecurringSettings(eventForm, eventForm.timezone.offset)}
            </p>
          </div>
        ) : null}

        <div className="form-group recurring-btns">
          <button
            type="button"
            className="btn btn-sm btn-warning recurring-btn"
            title="Cancel Recurrence"
            onClick={this.handeRecurringCancel}
          >
            <span className="icon cancel-circled recurring-icon" />
            <span>Cancel</span>
          </button>
          <button
            type="button"
            className="btn btn-sm btn-success recurring-btn"
            title="Apply Recurrence"
            onClick={this.handeRecurringApply}
          >
            <span className="icon checkmark-circle recurring-icon" />
            <span>Apply</span>
          </button>
        </div>

        <div>
          {eventModalData.recurringErrors && Object.keys(eventModalData.recurringErrors).length ? (
            <div className="form-group">
              <div className="panel panel-warning panel-min-height">
                <div className="panel-heading">
                  <h4 className="panel-title">
                    <span className="icon warning" /> Event Recurring Errors
                  </h4>
                </div>
                <table className="table table-hover table-sm">
                  <tbody>
                    <tr>
                      <th>
                        <b>Reason</b>
                      </th>
                      <th width="120px" className="text-right">
                        <b>Date</b>
                      </th>
                    </tr>
                    {Object.keys(eventModalData.recurringErrors).map(timestamp => {
                      return (
                        <tr key={timestamp}>
                          <td>
                            {eventModalData.recurringErrors[timestamp].errors.map((e, i) => (
                              <div key={`text-${timestamp}-${e}-${i}`}>{e}</div>
                            ))}
                          </td>
                          <td className="text-right">
                            <div>
                              {formatDate(
                                timestamp,
                                this.props.timezone.offset,
                                dateFormatSettings[user.settings.date]
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ) : null}
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => ({
  URL: state.URL,
  user: state.user,
  eventModalData: state.eventModalData,
  eventForm: state.eventForm,
  timezone: state.timezone,
  repsIntervalOptions: selectRepsIntervalOptions(state),
  recurringTypeOptions: selectRecurringTypeOptionsOptions(state)
});

export default connect(
  mapStateToProps,
  {
    checkEventParams,
    ...formActions
  },
  mergeActionsToProps
)(EventRecurring);
